import Axios from 'axios'
import { addParametersToUrl } from 'src/utils/url'

// guarantees order from least to most access:
export const ShareUniversalAccessIndex = {
  universal_audience_restricted: 0,
  universal_domain_restricted: 1,
  universal: 2,
}

export const ShareUniversalAccessOptions = [
  'universal',
  'universal_domain_restricted',
  'universal_audience_restricted',
] as const // `as const` allows us to index the values in a type, shown below
export type ShareUniversalAccessOption = typeof ShareUniversalAccessOptions[number]

export const TeamShareUniversalAccessOptions = [
  'unselected',
  'universal',
  'universal_domain_restricted',
  'universal_audience_restricted',
] as const // `as const` allows us to index the values in a type, shown below
export type TeamShareUniversalAccessOption = typeof TeamShareUniversalAccessOptions[number]

export interface IShareUniversal {
  shareUrl?: string
  access?: ShareUniversalAccessOption
  maxAccessFolderShareToken?: {
    access: ShareUniversalAccessOption
  }
  actions: {
    createUrl?: string
    updateAccessUrl?: string
  }
}

export function canAccess(shareable: IShareUniversal) {
  return !!shareable?.shareUrl || !!shareable?.actions?.createUrl
}

export async function getUniversalShareUrl(shareable: IShareUniversal, access?: ShareUniversalAccessOption) {
  if (!shareable.shareUrl && shareable.actions.createUrl) {
    // The access param is ignored for calls
    // as that is now dependent on preferences.default_share_access
    const createUrl = access ? addParametersToUrl(shareable.actions.createUrl, { access }) : shareable.actions.createUrl

    await Axios.post<IShareUniversal>(createUrl).then((response) => {
      shareable.shareUrl = response.data.shareUrl
      shareable.access = response.data.access
      shareable.actions = response.data.actions
    })
  }

  return shareable.shareUrl
}
